import React from 'react';
import { gettext } from '@eb/i18n';
import PropTypes from 'prop-types';
import Banner from './Banner';

const MAINTENANCE_HEADER = gettext('Site maintenance');
const MAINTENANCE_BODY = gettext(
    'We’ll be performing routine site maintenance starting at 2am CT today. We expect this to take up to 30 minutes, and some features may be unavailable during that time. For the latest status update, refer to',
);

const SiteMaintenanceBanner = (props) => {
    const trackingData = {
        type: 'TRACK_SITE_MAINTENANCE_BANNER_CLICK',
        meta: {
            analytics: {
                action: 'SiteMaintenanceBannerClick',
                category: props.category,
            },
        },
    };

    const destinationURL = 'https://www.eventbritestatus.com/';

    return (
        <Banner
            leftAccentColor="#F05537"
            style="light"
            header={MAINTENANCE_HEADER}
        >
            <span>
                {MAINTENANCE_BODY}{' '}
                <a
                    onClick={() => {
                        props.handleTracking(trackingData);
                    }}
                    rel="noopener noreferrer"
                    target="_blank"
                    href={destinationURL}
                >
                    www.eventbritestatus.com
                </a>
                .
            </span>
        </Banner>
    );
};

SiteMaintenanceBanner.propTypes = {
    handleTracking: PropTypes.func,
    trackingParams: PropTypes.string,
    category: PropTypes.string,
};

export default SiteMaintenanceBanner;
